import { CardBox } from '@/components/ui/CardBox';
import { Icon } from '@/components/ui/Icon';
import { mdiFilterRemove } from '@mdi/js';
import * as React from 'react';

interface NotificationsFiltersProps {
  selectedType: string;
  onTypeChange: (type: string) => void;
  onClearFilters: () => void;
}

const notificationTypeOptions: { value: string; label: string }[] = [
  { value: '', label: 'All Types' },
  { value: 'plan_reminder', label: 'Plan Reminder' },
  { value: 'plan_created_by_admin', label: 'Plan Created' },
  { value: 'review_reminder', label: 'Review Reminder' },
  { value: 'announcement', label: 'Announcement' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'system', label: 'System' },
];

export const NotificationsFilters: React.FC<NotificationsFiltersProps> = ({
  selectedType,
  onTypeChange,
  onClearFilters,
}) => {
  const hasFilters = selectedType !== '';

  return (
    <CardBox className='!p-4'>
      <div className='flex flex-wrap items-center gap-4'>
        <div className='flex-1 min-w-[200px]'>
          <label className='block text-xs font-medium text-grey-500 mb-1'>
            Type
          </label>
          <select
            value={selectedType}
            onChange={e => onTypeChange(e.target.value)}
            className='w-full px-3 py-2 border border-grey-300 rounded-lg text-sm focus:ring-2 focus:ring-coffice-blue focus:border-coffice-blue'
          >
            {notificationTypeOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        {hasFilters && (
          <div className='flex items-end'>
            <button
              onClick={onClearFilters}
              className='inline-flex items-center px-3 py-2 text-sm text-grey-600 hover:text-grey-900 hover:bg-grey-100 rounded-lg transition-colors'
            >
              <Icon path={mdiFilterRemove} size={18} className='mr-1' />
              Clear Filters
            </button>
          </div>
        )}
      </div>
    </CardBox>
  );
};
